import { render, staticRenderFns } from "./MailAttachmentListBuilder.vue?vue&type=template&id=a52cdef8&scoped=true"
import script from "./MailAttachmentListBuilder.vue?vue&type=script&lang=js"
export * from "./MailAttachmentListBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52cdef8",
  null
  
)

export default component.exports